import React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import NotFoundLogo from "../Configs/Assets/404.svg";

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
      }}
    >
      <img src={NotFoundLogo} alt="Error 404 Logo" style={{ marginTop: 15, maxWidth: "100%", height: "auto" }} />
      <Typography variant={"h2"} sx={{ marginTop: 5, color: "#656565" }}>
        Oops
      </Typography>
      <Typography variant={"h4"} sx={{ marginTop: 3, color: "#656565" }}>
        Página não encontrada
      </Typography>
    </Box>
  );
}
